<script>
    import Email from '/srv/web/wyvr/html/releases/58819/gen/client/form/Email.svelte?1733898724838';
    import Dialog from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Dialog.svelte?1733898724838';
    import Spinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Spinner.svelte?1733898724838';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724838';
    import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898724838';
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724838';
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/Image.svelte?1733898724838';
    import { inquiry } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/inquiry.js?1733898724838';
    import { price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/store.js?1733898724838';

    export let product;
    export let open = false;
    $: id = get_attribute_value(product, 'entity_id');
    $: name = get_attribute_value(product, 'name');
    $: image_src = get_attribute_value(product, 'image');
    $: src = image_src ? get_image_path(image_src) : null;
    $: disabled = !id || !email;

    let email = "";
    let state = 'idle';

    async function action() {
        // @TODO validate email
        if (!id || !email || email.indexOf('@') == -1) {
            messages.push(window.__('price_request.error'), 'error');
            return;
        }
        state = 'busy';

        const [error, result] = await inquiry(id, email);
        if (error || !result?.id) {
            messages.push(window.__('price_request.error'), 'error');
        } else {
            messages.push(window.__('price_request.success'), 'success');
            price_request.update((ids) => {
                return [...ids, id].filter((cur, i, arr) => arr.indexOf(cur) === i);
            });
        }
        state = 'idle';

        open = false;
    }
</script>

<Dialog id={'price_request'} bind:open title={window.__('price_request.title')}>
    <div class="content c-product-price-request__content">
        {#if state == 'idle'}
            {#if name}
                <div>
                    {#if src}
                        <Image {src} width={200} height={200} alt={name} />
                    {/if}
                    <b class="product-name">{@html name}</b>
                </div>
            {/if}
            <p>{@html window.__('price_request.text')}</p>
            <Email id={'price_request_email'} focus={open} bind:value={email}
                >{window.__('customer.email')}</Email
            >
            <div class="footer">
                <button on:click|preventDefault={() => (open = false)} type="button" class="btn m-button"
                    >{window.__('shop.close')}</button
                >
                <button class="btn m-button m-button--primary" type="submit" {disabled} on:click|preventDefault={action}
                    >{window.__('price_request.short_action')}</button
                >
            </div>
        {:else}
            <Spinner />
        {/if}
    </div>
</Dialog>

<style>
    .product-name {
        color: var(--font-heading-color__base_light);
    }

    .footer {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        border-top: 1px solid var(--whitegray);
        padding: 15px 0;
        margin-top: 1rem;
    }
</style>